import { render, staticRenderFns } from "./HorizontalClientSlider.vue?vue&type=template&id=3b775eda&scoped=true&"
import script from "./HorizontalClientSlider.vue?vue&type=script&lang=js&"
export * from "./HorizontalClientSlider.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalClientSlider.vue?vue&type=style&index=0&id=3b775eda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b775eda",
  null
  
)

export default component.exports